import {useParams} from 'react-router-dom'
import {parseISO} from 'date-fns'

import styles from './BrokerProject.module.scss'
import {
  Paper,
  Back,
  Loader,
  Panel,
  MeterStat,
  CentsMoney,
  Period,
} from 'common/components'
import {formatMoney} from 'common/helpers'
import {
  UserProjectScheduleList,
  BrokerChart,
  useGetProject,
  useGetProjectTransactions,
} from '..'

export default function BrokerProject() {
  const params = useParams()
  const {data: project} = useGetProject(params.uuid)
  const {data: transactions} = useGetProjectTransactions(params.uuid)

  return (
    <Paper relative>
      <Back to="/projects" />
      {project && transactions ? (
        <>
          <Panel img={project.image} title={project.title} />
          <div className={styles.content}>
            <div className={styles.stats}>
              <MeterStat
                large
                type="green"
                title="Current balance"
                value={<CentsMoney value={project.balance} />}
                label={`${formatMoney(project.availableBalance)} available`}
              />
              <MeterStat
                large
                type="grey"
                title="Facility limit 2"
                value={<CentsMoney value={project.facilityLimit2} />}
                label="including interest & fees"
              />
              <BrokerChart project={project} />
            </div>
            <Period
              className={styles.period}
              openDate={parseISO(project.openDate)}
              maturityDate={parseISO(project.maturityDate)}
            />
          </div>
          <UserProjectScheduleList />
        </>
      ) : (
        <Loader />
      )}
    </Paper>
  )
}
